<template>
  <v-card tile :color="config.background" :dark="config.dark">
    <v-card-text class="text-center subtitle-1">
      <v-row align="center" dense no-gutters>
        <v-col cols="6">
          <v-avatar class="ma-3" size="80" tile>
            <v-img src="../../assets/images/dashboard/mujer.png"></v-img>
          </v-avatar>
          <div class="text-center text-h4 font-weight-bold">55 %</div>
          <div class="title">555</div>
        </v-col>
        <v-col cols="6">
          <v-avatar class="ma-3" size="80" tile>
            <v-img src="../../assets/images/dashboard/hombre.png"></v-img>
          </v-avatar>
          <div class="text-center text-h4 font-weight-bold">45 %</div>
          <div class="title">445</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Indicator-Card',
  props: ['config'],
  data: () => ({
    configuration: {
      background: 'light-green darken-3',
      background_dark: 'light-green darken-4',
      dark: false
    },
    information: {
      name: '',
      amount: 30
    }
  }),
  created () {
    if (this.config) {
      this.configuration = this.config
      this.information = this.config.data
    }
  }
}
</script>

<style>

</style>
